import $ from 'jquery'

export function tourTimePriceUpdate() {
  var price = parseFloat($('.amount').data('price'))
  var tourTime = parseFloat($('#tour-time').val())

  var total = price * tourTime

  var formattedPrice = price.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  })

  var TotalPrice = total.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  })

  $('.get-offer__fee-name').text(formattedPrice + ' x ' + tourTime + ' saat')
  $('.get-offer__fee').text(TotalPrice)

  return total
}

export function calculateMealTotal() {
  let total = 0

  $('#yemekler .single-menu__meal-checkbox:checked').each(function () {
    const priceType = parseFloat($(this).data('calc-price'))
    let mealPrice = parseFloat(
      $(this)
        .closest('.single-menu__wrapper')
        .find('.single-menu__price .single-menu__amount')
        .text()
        .replace('₺', '')
        .replace('.', '')
        .replace(',', '.')
    )

    if (priceType === 0) {
      total += mealPrice
    } else if (priceType === 1) {
      const personCount = $('#number-of-people').val()
      total += mealPrice * personCount
    }
  })

  const totalPrice = total.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  })

  $('.get-offer__meal-fee').text(totalPrice)

  return total
}

export function calculatePackageTotal() {
  let total = 0

  $('#paketler .single-menu__packages-checkbox:checked').each(function () {
    const priceType = parseFloat($(this).data('calc-price'))
    let packagePrice = parseFloat(
      $(this)
        .closest('.single-menu__wrapper')
        .find('.single-menu__price .single-menu__amount')
        .text()
        .replace('₺', '')
        .replace('.', '')
        .replace(',', '.')
    )

    if (priceType === 0) {
      total += packagePrice
    } else if (priceType === 1) {
      let tourTime = parseFloat($('#tour-time').val())
      total += packagePrice * tourTime
    } else if (priceType === 2) {
      const personCount = $('#number-of-people').val()
      total += packagePrice * personCount
    }
  })

  return total
}

export function calculateExtraTotal() {
  let total = 0

  const checkbox_extras = document.getElementsByName('extra-selection')

  checkbox_extras.forEach((checkbox_extra) => {
    if (checkbox_extra.checked) {
      const priceType = parseInt(checkbox_extra.getAttribute('data-calc-price'))

      let extraPrice = parseFloat(
        checkbox_extra
          .closest('.single-menu__wrapper')
          .querySelector('.single-menu__price .single-menu__amount')
          .textContent.replace('₺', '')
          .replace('.', '')
          .replace(',', '.')
      )

      if (priceType === 0) {
        total += extraPrice
      } else if (priceType === 1) {
        let tourTime = parseFloat($('#tour-time').val())
        total += extraPrice * tourTime
      } else if (priceType === 2) {
        const personCount = $('#number-of-people').val()
        total += extraPrice * personCount
      }
    }
  })
  return total
}

export function calculateExtraPackageTotal() {
  const packageTotal = calculatePackageTotal()
  const extraTotal = calculateExtraTotal()

  const total = packageTotal + extraTotal

  const totalPrice = total.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  })

  $('.get-offer__extra-fee').text(totalPrice)
}

export function calculateAllFee() {
  const packageTotal = calculatePackageTotal()
  const extraTotal = calculateExtraTotal()
  const mealTotal = calculateMealTotal()
  const rentTotal = tourTimePriceUpdate()

  const total = packageTotal + extraTotal + mealTotal + rentTotal

  const totalPrice = total.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  })

  $('.get-offer__all-fee').text(totalPrice)
}
